import { render, staticRenderFns } from "./check-materials-modal.vue?vue&type=template&id=3525fc66&scoped=true"
import script from "./check-materials-modal.vue?vue&type=script&lang=js"
export * from "./check-materials-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525fc66",
  null
  
)

export default component.exports